import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import I18n from '@src/i18n';
import { Steps } from 'antd';
import React from 'react';

import { ContainerCircle, ItemDiv } from '../Scheduler/schedulerStyles';


interface propType {
  stepsObjectArray: {
    icon: string,
    label: string
  }[]
  currentStep: number;
}

const returnIcon = (icon: string, label: string) => {
  return (
    <ItemDiv >
      <ContainerCircle>
        <FontAwesomeIcon icon={`${icon}`} />
      </ContainerCircle>
      <p>{I18n.l(`${label}`)}</p>
    </ItemDiv>
  )
}

const StepsVisualizer = (props: propType) => {
  const { Step } = Steps
  const { currentStep, stepsObjectArray } = props
  return (
    <div>
      <Steps current={ currentStep }>
          {stepsObjectArray.map((step: any) => <Step icon={returnIcon(step.icon, step.label)} /> )}
      </Steps>
    </div>
  )
}

StepsVisualizer.defaultProps = {
  currentStep: 0
}

export default StepsVisualizer
